(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lasyme-responsive-video')) {
    customElements.define('lasyme-responsive-video', class extends HTMLElement {
      connectedCallback() {
        if (this.mediaQuery) return;

        this.mediaQuery = window.matchMedia('(max-width: 767.98px)');
        this.handleViewportChange = () => {
          // The video's <source media> conditions select one device-specific file.
          // An explicit reload also updates that selection after a viewport change.
          const video = this.querySelector('video');
          if (!video) return;

          const poster = this.mediaQuery.matches
            ? this.dataset.mobilePoster
            : this.dataset.desktopPoster;

          video.pause();
          if (poster) video.poster = poster;
          video.load();

          const playback = video.play();
          if (playback && typeof playback.catch === 'function') {
            playback.catch(() => {
              // Keep the native poster if the browser prevents autoplay.
            });
          }
        };

        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.handleViewportChange);
        } else {
          this.mediaQuery.addListener(this.handleViewportChange);
        }
      }

      disconnectedCallback() {
        if (!this.mediaQuery) return;

        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.handleViewportChange);
        } else {
          this.mediaQuery.removeListener(this.handleViewportChange);
        }

        const video = this.querySelector('video');
        if (video) video.pause();
        this.mediaQuery = null;
        this.handleViewportChange = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
